export interface Cosmetics {
  skinId: string;
  trailId: string;
  collisionEffectId: string;
  victoryAnimationId: string;
  title: string;
  badge: string;
}

export enum CosmeticType {
  BaseColor = 'base_color',
  Skin = 'skin',
  Pattern = 'pattern',
  Flag = 'flag',
  Letter = 'letter',
  Accessory = 'accessory',
  Trail = 'trail',
  Nameplate = 'nameplate',
  Badge = 'badge',
  VictoryEffect = 'victory_effect',
}

export enum CosmeticRarity {
  Common = 'common',
  Rare = 'rare',
  Epic = 'epic',
  Legendary = 'legendary',
  Special = 'special',
}

export enum CurrencyType {
  Soft = 'soft_currency',
}

export type UnlockSource =
  | 'starter'
  | 'earned'
  | 'soft_currency_purchase'
  | 'premium_purchase'
  | 'achievement'
  | 'event'
  | 'tutorial'
  | 'admin'
  | 'migration';

export interface UserLoadoutDTO {
  userId: string;
  baseColorId: string | null;
  skinId: string | null;
  patternId: string | null;
  flagId: string | null;
  letterId: string | null;
  accessoryId: string | null;
  accessoryColor?: string | null;
  trailId: string | null;
  nameplateId: string | null;
  badgeId: string | null;
  victoryEffectId: string | null;
}

export interface WalletDTO {
  userId: string;
  softCurrency: number;
}

export interface CosmeticCatalogEntry {
  id: string;
  slug: string;
  type: CosmeticType;
  nameKey: string;
  descriptionKey: string;
  rarity: CosmeticRarity;
  assetKey: string | null;
  priceSoftCurrency: number | null;
  enabled: boolean;
  isDefault: boolean;
  metadata: Record<string, unknown>;
}

export interface LastMeaningfulHit {
  attackerPlayerId: string;
  attackerUserId: string | null;
  serverTick: number;
  timestamp: number;
  impulseStrength: number;
  collisionType: string;
}

export type PublicPlayerAppearance = {
  baseColorId: string;
  skinId: string | null;
  patternId: string | null;
  flagId: string | null;
  letterId: string | null;
  accessoryId: string | null;
  accessoryColor?: string | null;
  trailId: string | null;
  nameplateId: string | null;
  badgeId: string | null;
  victoryEffectId: string | null;
};

export type PlayerLoadout = PublicPlayerAppearance;
